var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "yxt-select-dropdown__item",
      class: [
        _vm.itemSelectedClass,
        {
          selected: _vm.itemSelected,
          hover: _vm.isHover,
          "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
          "is-labelTooltip": _vm.labelTooltip,
        },
      ],
      on: {
        mouseenter: _vm.hoverItem,
        mouseout: _vm.mouseoutItem,
        mousemove: _vm.enableMouseEnter,
        click: function ($event) {
          $event.stopPropagation()
          return _vm.selectOptionClick($event)
        },
      },
    },
    [
      _vm.select.multipleStyle === "checkbox"
        ? _c("yxt-checkbox", {
            class: ["selected-multiple-checkbox"],
            attrs: { disabled: _vm.itemDisabled },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
              },
            },
            model: {
              value: _vm.itemSelected,
              callback: function ($$v) {
                _vm.itemSelected = $$v
              },
              expression: "itemSelected",
            },
          })
        : _vm._e(),
      _vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])]),
      _vm.labelTooltip
        ? _c(
            "yxt-tooltip",
            {
              attrs: {
                effect: _vm.tooltipEffect,
                content: _vm.labelTooltip,
                placement: "top-start",
                offset: 10,
                "max-width": _vm.labelTooltipWidth,
              },
            },
            [
              _c("yxt-svg", {
                staticClass: "color-gray-6 hover-primary-6 ml4 question-svg",
                attrs: {
                  "remote-url": "",
                  width: "16px",
                  height: "16px",
                  "icon-class": "question-cirlce-o",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }